// ### Imports
// * Import lib
import React from "react";

// * Import 3rd party lib
import { Box, Typography, useTheme } from "@mui/material";

import noAccessImg from "../../../assets/images/no_access.svg";

function PageNotFound({ contact = "admin", style = {} }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        margin: theme.margin[2],
        fontWeight: theme.fontWeight[500],
        ...style,
      }}
    >
      <img
        style={{
          width: theme.size[200],
          height: theme.size[200],
          marginBottom: theme.size[50],
        }}
        src={noAccessImg}
        alt=""
      />
      <Typography sx={{ fontSize: theme.size[24], fontWeight: 500 }}>
        {`You don't have access to this page, Please contact ${contact}.`}
      </Typography>
      <br></br>
    </Box>
  );
}

export default PageNotFound;
